import React, {Component} from 'react';
import {addScenarioToCart, updateShoppingCart} from '../actions/addToCartAction'
import { connect } from "react-redux";
//import Cart from '../components/CartComponent'
import PropTypes from 'prop-types';

class Table extends Component {
    constructor(props){
      super(props)
      this.handleAddOperation = this.handleAddOperation.bind(this)
    }

    handleAddOperation(e){
      let buttonValue = e.target.innerHTML
      if (buttonValue === "Add To Cart") {
        let seq = this.props.count+1
        const obj = {
            count: this.props.count,
            items : this.props.data.filter((element) => {
                return element['Scenario UUID'] === e.target.id
            }).map((element) => {
                return {
                    scenario_id : element['Scenario Id'],
                    scenario_uuid: element['Scenario UUID'],
                    sequence: seq
                }
            })
        }
      this.props.dispatch(addScenarioToCart(obj))
    }
    else{
      const prevData = this.props.items
      const [removedItem] = this.props.data.filter((element) => element['Scenario UUID'] === e.target.id)
      const newData = prevData.filter((element) => element.scenario_id !== removedItem['Scenario Id'])

      const finalData = newData.map((data)=>{
        if (data.scenario_id < removedItem['Scenario Id']){
          return {
            scenario_id : data.scenario_id,
            scenario_uuid : data.scenario_uuid,
            sequence : data.sequence,
          }
        }
        else if (data.scenario_id > removedItem['Scenario Id']){
          return {
            scenario_id : data.scenario_id,
            scenario_uuid : data.scenario_uuid,
            sequence : data.sequence-1,
          }
        }
        return {
          scenario_id : data.scenario_id,
          scenario_uuid : data.scenario_uuid,
          sequence : data.sequence-1,
        }
      });

        const obj = {
          count: this.props.count-1,
          items : finalData
        }

      this.props.dispatch(updateShoppingCart(obj))

    }
    }


    render () {
        const tableHead = this.props.data.length > 0 ? Object.keys(this.props.data[0]) : undefined;
        let final_data = []
        if (this.props.selected.length === 0){
          final_data = this.props.data
        }
        else if ( this.props.selected === "Select Function"){
          final_data = this.props.data
        }
        else{
        final_data = this.props.data.filter(obj => obj.Function === this.props.selected)
        }

        console.log("Final_data : ", final_data)
        return (
        <div>
            {final_data.length > 0 ? <table className="table">
                <thead >
                    <tr>

                        {tableHead.map((value, index) => {
                          if(value === 'Function'){
                            return ""
                          }
                          return <th scope="col" key={index} className="table-head" style={{ borderBottom: "4px solid #622AD8", verticalAlign : "top"}}>{value}</th>
                        }
                      )}
                        <th scope="col" className="table-head" style={{ borderBottom: "4px solid #622AD8", verticalAlign : "top"}}></th>
                        { /* <th scope="col" key="action" style={{ display: "none"}}>Action</th> */}
                    </tr>
                </thead>
                  <tbody>
                    {final_data.map( (element, index) => {
//                     if (this.props.selected.length == 0){
                        return (
                          <tr key={index} className="table-row">

                                    {Object.keys(element).map((subElement, subIndex) => {
                                        if (subElement === "Test data"){
                                            return element[subElement] !== null ? <td><i className="fa fa-check"></i></td> : <td style={{ color : "white"}}><i className="fa fa-window-close"></i></td>
                                        }
                                        if (subElement === "GT data"){
                                            return element[subElement] !== null ? <td><i className="fa fa-check"></i></td> : <td style={{ color : "white"}}><i className="fa fa-window-close"></i></td>
                                        }
                                        if(subElement === "Function"){
                                          return ""
                                        }

                                        return <td key={subIndex}>{element[subElement]}</td>


                                    })}
                                    { /* <td>
                                        <button className="btn" style={{ display: "none" }}><i class="fa fa-edit"></i></button>
                                        <button className="btn" style={{ display: "none" }}><i class="fa fa-trash"></i></button>
                                    </td> */ }
                                    <td>
                                      <div className="form-group">
                                         <button type="submit" className="btn" id = {element['Scenario UUID']} style={{backgroundColor:"#4812cc"}} onClick = {(e) => {this.handleAddOperation(e)}}>
                                            {this.props.items.some(obj=>obj.scenario_uuid === element['Scenario UUID'])?"Remove From Cart":"Add To Cart"}
                                         </button>
                                       </div>

                                    </td>

                                </tr>
                              )


                    })}

                </tbody>
            </table>
            : <div className="alert alert-secondary" role="alert">
                No data available
              </div>}
        </div>
        )
    }
}
Table.propTypes={
count:PropTypes.number,
data:PropTypes.string,
dispatch:PropTypes.string,
items:PropTypes.string,
selected:PropTypes.bool,
}
Table.defaultProps= {
count:1,
data:[],
dispatch:[],
items:[],
selected:true,
}

const mapStateToProps = (state) => {
    return {
        count : state.cartItems.count,
        items : state.cartItems.items
    }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

//     })

//     //this.props.dispatch(editScenarioGroupData(submitValue));
//     //this.props.handleEditModalClose();
// };


export default connect(mapStateToProps)(Table);
